package noman.components.sections.projects.style

import com.varabyte.kobweb.silk.style.extendedBy
import noman.components.styles.SectionContainerStyle

val ProjectsStyle = SectionContainerStyle.extendedBy {


}